export default __webpack_public_path__ + "static/media/certificate.c5206821.svg";